import { useEffect, useRef, useState, useMemo } from "react";
import LeadGateModal from "../Modals/LeadGateModal.jsx";
import SuccessModal from "../Modals/SuccessModal.jsx";
import ConfirmSendResultsModal from "../Modals/ConfirmSendResultsModal.jsx";
import UpdateEmailModal from "../Modals/UpdateEmailModal.jsx";

import { detectToolsOrigin } from "../../../utils/helper.js";
import axios from "axios";
import "../calculator.scss";

// ===== YEAR CONFIG: DISCLAIMER (same pattern as Bonus) =====
const YEAR_CONFIG = {
  2025: {
    disclaimer:
      "This calculator provides estimates only. Consult a tax professional for personalized advice.",
  },
  2026: {
    disclaimer:
      "This calculator provides estimates only. Consult a tax professional for personalized advice.",
  },
};

// ===== YEAR CONFIG: BRACKETS + NIIT =====
const CRYPTO_TAX_CONFIG = {
  2025: {
    taxBrackets: {
      "Single": {
        shortTerm: [
          { min: 0, max: 11600, rate: 0.1 },
          { min: 11600, max: 47150, rate: 0.12 },
          { min: 47150, max: 100525, rate: 0.22 },
          { min: 100525, max: 191950, rate: 0.24 },
          { min: 191950, max: 243725, rate: 0.32 },
          { min: 243725, max: 609350, rate: 0.35 },
          { min: 609350, max: Infinity, rate: 0.37 },
        ],
        longTerm: [
          { min: 0, max: 48350, rate: 0.0 },
          { min: 48350, max: 533400, rate: 0.15 },
          { min: 533400, max: Infinity, rate: 0.2 },
        ],
        niitThreshold: 200000,
      },

      "Married Filing Jointly": {
        shortTerm: [
          { min: 0, max: 23200, rate: 0.1 },
          { min: 23200, max: 94300, rate: 0.12 },
          { min: 94300, max: 201050, rate: 0.22 },
          { min: 201050, max: 383900, rate: 0.24 },
          { min: 383900, max: 487450, rate: 0.32 },
          { min: 487450, max: 731200, rate: 0.35 },
          { min: 731200, max: Infinity, rate: 0.37 },
        ],
        longTerm: [
          { min: 0, max: 96700, rate: 0.0 },
          { min: 96700, max: 583750, rate: 0.15 },
          { min: 583750, max: Infinity, rate: 0.2 },
        ],
        niitThreshold: 250000,
      },

      "Married Filing Separately": {
        shortTerm: [
          { min: 0, max: 11600, rate: 0.1 },
          { min: 11600, max: 47150, rate: 0.12 },
          { min: 47150, max: 100525, rate: 0.22 },
          { min: 100525, max: 191950, rate: 0.24 },
          { min: 191950, max: 243725, rate: 0.32 },
          { min: 243725, max: 365600, rate: 0.35 },
          { min: 365600, max: Infinity, rate: 0.37 },
        ],
        longTerm: [
          { min: 0, max: 48350, rate: 0.0 },
          { min: 48350, max: 291850, rate: 0.15 },
          { min: 291850, max: Infinity, rate: 0.2 },
        ],
        niitThreshold: 125000,
      },

      "Head of Household": {
        shortTerm: [
          { min: 0, max: 17400, rate: 0.1 },
          { min: 17400, max: 63200, rate: 0.12 },
          { min: 63200, max: 100500, rate: 0.22 },
          { min: 100500, max: 191950, rate: 0.24 },
          { min: 191950, max: 243700, rate: 0.32 },
          { min: 243700, max: 609350, rate: 0.35 },
          { min: 609350, max: Infinity, rate: 0.37 },
        ],
        longTerm: [
          { min: 0, max: 76950, rate: 0.0 },
          { min: 76950, max: 551350, rate: 0.15 },
          { min: 551350, max: Infinity, rate: 0.2 },
        ],
        niitThreshold: 200000,
      },
    },
  },

  2026: {
    taxBrackets: {
      "Single": {
        shortTerm: [
          { min: 0, max: 12400, rate: 0.1 },
          { min: 12401, max: 50400, rate: 0.12 },
          { min: 50401, max: 105700, rate: 0.22 },
          { min: 105701, max: 201775, rate: 0.24 },
          { min: 201776, max: 256225, rate: 0.32 },
          { min: 256226, max: 640600, rate: 0.35 },
          { min: 640601, max: Infinity, rate: 0.37 },
        ],
        longTerm: [
          { min: 0, max: 49450, rate: 0.0 },
          { min: 49451, max: 545500, rate: 0.15 },
          { min: 545501, max: Infinity, rate: 0.2 },
        ],
        niitThreshold: 200000,
      },

      "Married Filing Jointly": {
        shortTerm: [
          { min: 0, max: 24800, rate: 0.1 },
          { min: 24801, max: 100800, rate: 0.12 },
          { min: 100801, max: 211400, rate: 0.22 },
          { min: 211401, max: 403550, rate: 0.24 },
          { min: 403551, max: 512450, rate: 0.32 },
          { min: 512451, max: 768700, rate: 0.35 },
          { min: 768701, max: Infinity, rate: 0.37 },
        ],
        longTerm: [
          { min: 0, max: 98900, rate: 0.0 },
          { min: 98901, max: 613700, rate: 0.15 },
          { min: 613701, max: Infinity, rate: 0.2 },
        ],
        niitThreshold: 250000,
      },

      "Married Filing Separately": {
        shortTerm: [
          { min: 0, max: 12400, rate: 0.1 },
          { min: 12401, max: 50400, rate: 0.12 },
          { min: 50401, max: 105700, rate: 0.22 },
          { min: 105701, max: 201775, rate: 0.24 },
          { min: 201776, max: 256225, rate: 0.32 },
          { min: 256226, max: 384350, rate: 0.35 },
          { min: 384351, max: Infinity, rate: 0.37 },
        ],
        longTerm: [
          { min: 0, max: 49450, rate: 0.0 },
          { min: 49451, max: 306850, rate: 0.15 },
          { min: 306851, max: Infinity, rate: 0.2 },
        ],
        niitThreshold: 125000,
      },

      "Head of Household": {
        shortTerm: [
          { min: 0, max: 17700, rate: 0.1 },
          { min: 17701, max: 67450, rate: 0.12 },
          { min: 67451, max: 105700, rate: 0.22 },
          { min: 105701, max: 201775, rate: 0.24 },
          { min: 201776, max: 256225, rate: 0.32 },
          { min: 256226, max: 640600, rate: 0.35 },
          { min: 640601, max: Infinity, rate: 0.37 },
        ],
        longTerm: [
          { min: 0, max: 66200, rate: 0.0 },
          { min: 66201, max: 579600, rate: 0.15 },
          { min: 579601, max: Infinity, rate: 0.2 },
        ],
        niitThreshold: 200000,
      },
    },
  },
};

// ===== SHARED HELPERS =====
const taxAt = (amount, brackets) => {
  let total = 0;
  for (const b of brackets) {
    if (amount > b.min) {
      const taxable = Math.min(amount, b.max) - b.min;
      total += taxable * b.rate;
    }
  }
  return total;
};

const incrementalTax = (base, delta, brackets) => {
  if (delta <= 0) return 0;
  return taxAt(base + delta, brackets) - taxAt(base, brackets);
};

// ---------- PROXY (same pattern as Federal) ----------
const PROXY_URL =
  window.__UK_PROXY_URL__ || `${detectToolsOrigin()}/.netlify/functions/api-proxy`;

// ===== MAIN COMPONENT =====
function CryptocurrencyTaxCalculator({
  year = 2025,
  calculatorName = "Cryptocurrency Tax Calculator",
  endpoint = PROXY_URL,
}) {
  const config = CRYPTO_TAX_CONFIG[year] || CRYPTO_TAX_CONFIG[2025];
  const taxBrackets = config.taxBrackets;

  const yearCfg = YEAR_CONFIG[year] || YEAR_CONFIG[2025];

  // ✅ default can be "Single" or empty - your choice
  const [filingStatus, setFilingStatus] = useState("");
  const [income, setIncome] = useState("");
  const [acquisitionMethod, setAcquisitionMethod] = useState("");
  const [costBasis, setCostBasis] = useState("");
  const [saleProceeds, setSaleProceeds] = useState("");
  const [giftCostBasis, setGiftCostBasis] = useState("");
  const [giftFMV, setGiftFMV] = useState("");
  const [holdingPeriod, setHoldingPeriod] = useState("");
  const [results, setResults] = useState(null);

  const pageUrl = typeof window !== "undefined" ? window.location.href : "";
  const resultsRef = useRef(null);

  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const qa = useMemo(() => params.has("qa_mode"), [params]);

  const latestPayloadRef = useRef({
    inputs_json: null,
    results_json: null,
    pdf_notes: null,
  });

  const UNK_GATE_KEY = "unk_calc_unlock_v1";
  const UNK_GATE_TTL_MS = 24 * 60 * 60 * 1000;

  const readUnlock = () => {
    try {
      const raw = localStorage.getItem(UNK_GATE_KEY);
      if (!raw) return { unlocked: false, email: "" };
      const parsed = JSON.parse(raw);
      const expiresAt = Number(parsed?.expiresAt || 0);
      const email = String(parsed?.email || "");
      if (!expiresAt || Date.now() > expiresAt) {
        localStorage.removeItem(UNK_GATE_KEY);
        return { unlocked: false, email: "" };
      }
      return { unlocked: true, email };
    } catch {
      return { unlocked: false, email: "" };
    }
  };

  const writeUnlock = ({ email }) => {
    const payload = {
      expiresAt: Date.now() + UNK_GATE_TTL_MS,
      email: String(email || ""),
    };
    localStorage.setItem(UNK_GATE_KEY, JSON.stringify(payload));
  };

  const [unlocked, setUnlocked] = useState(false);
  const [storedEmail, setStoredEmail] = useState("");

  const [showLeadModal, setShowLeadModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showUpdateEmailModal, setShowUpdateEmailModal] = useState(false);

  const [sendingResults, setSendingResults] = useState(false);

  useEffect(() => {
    const gate = readUnlock();
    setUnlocked(gate.unlocked);
    setStoredEmail(gate.email || "");
  }, []);

  const scrollToResults = () => {
    const el = resultsRef.current;
    if (el && typeof el.scrollIntoView === "function") {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const openGateFlow = () => {
    if (unlocked) {
      setShowConfirmModal(true);
      return;
    }
    setShowLeadModal(true);
  };

  const handleLeadSuccess = ({ email }) => {
    writeUnlock({ email });
    setUnlocked(true);
    setStoredEmail(email || "");
    setShowLeadModal(false);
    setShowSuccessModal(true);
  };

  const handleSuccessViewResults = () => {
    setShowSuccessModal(false);
    scrollToResults();
  };

  const computeResults = () => {
    if (!filingStatus) return null;

    const incomeVal = Number(income) || 0;
    const proceeds = Number(saleProceeds) || 0;
    let basis = 0;
    let ordinaryIncome = 0;

    // Basis + gift dual-basis logic
    if (acquisitionMethod === "gift") {
      const donorBasis = Number(giftCostBasis) || 0;
      const fmv = Number(giftFMV) || 0;

      if (proceeds > donorBasis) {
        basis = donorBasis; // gain
      } else if (proceeds < fmv) {
        basis = fmv; // loss
      } else {
        const results_json = { capitalGain: 0, tax: 0, effectiveRate: 0 };

        const inputs_json = {
          filingStatus,
          income,
          acquisitionMethod,
          costBasis,
          saleProceeds,
          giftCostBasis,
          giftFMV,
          holdingPeriod,
          calculator_year: String(year),
        };

        const pdf_notes = {
          disclaimer: yearCfg.disclaimer,
          footer: {
            cta_title:
              "Want a personalized tax strategy? Speak with an Uncle Kam expert.",
            cta_subtitle: "Visit us at unclekam.com",
          },
        };

        return { inputs_json, results_json, pdf_notes };
      }
    } else {
      basis = Number(costBasis) || 0;

      if (acquisitionMethod === "payment" || acquisitionMethod === "goods") {
        ordinaryIncome = basis;
      }
    }

    const gain = proceeds - basis;
    const isShort = holdingPeriod === "short";

    const stBrackets = taxBrackets[filingStatus]?.shortTerm || [];
    const ltBrackets = taxBrackets[filingStatus]?.longTerm || [];
    const applicableBrackets = isShort ? stBrackets : ltBrackets;

    const capTax = gain > 0 ? incrementalTax(incomeVal, gain, applicableBrackets) : 0;

    const ordinaryTax =
      ordinaryIncome > 0 ? incrementalTax(incomeVal, ordinaryIncome, stBrackets) : 0;

    // ✅ updated: compare to spaced words key
    const maxOffset = filingStatus === "Married Filing Separately" ? 1500 : 3000;
    const lossOffsetBenefit = gain < 0 ? Math.min(-gain, maxOffset) * 0.22 : 0;

    let niit = 0;
    const filingCfg = taxBrackets[filingStatus];
    if (gain > 0 && filingCfg?.niitThreshold != null) {
      const threshold = filingCfg.niitThreshold;
      const approxMAGI = incomeVal + ordinaryIncome + Math.max(0, gain);
      const excess = Math.max(0, approxMAGI - threshold);
      niit = 0.038 * Math.min(gain, excess);
    }

    const totalTax = Math.max(0, capTax + ordinaryTax + niit - lossOffsetBenefit);
    const effectiveRate = gain > 0 ? (totalTax / gain) * 100 : 0;

    const results_json = {
      capitalGain: gain,
      tax: totalTax,
      effectiveRate,
    };

    const inputs_json = {
      filingStatus,
      income,
      acquisitionMethod,
      costBasis,
      saleProceeds,
      giftCostBasis,
      giftFMV,
      holdingPeriod,
      calculator_year: String(year),
    };

    const pdf_notes = {
      disclaimer: yearCfg.disclaimer,
      footer: {
        cta_title:
          "Want a personalized tax strategy? Speak with an Uncle Kam expert.",
        cta_subtitle: "Visit us at unclekam.com",
      },
    };

    return { inputs_json, results_json, pdf_notes };
  };

  const sendResultsToEmail = async (emailToSend) => {
    const payload = latestPayloadRef.current;
    if (!payload?.inputs_json || !payload?.results_json) return null;

    setSendingResults(true);

    try {
      const resp = await axios.post(
        PROXY_URL,
        {
          path: "/public/send-results",
          method: "POST",
          raw: true,
          qa_mode: qa,
          data: {
            action: "send_results_email",
            email: emailToSend,
            calculator_name: calculatorName,
            calculator_year: String(year),
            page_url: pageUrl,
            timestamp_utc: new Date().toISOString(),
            results_json: payload.results_json,
            inputs_json: payload.inputs_json,
            pdf_notes: payload.pdf_notes,
            schema_version: 1,
          },
        },
        { headers: { "Content-Type": "application/json" }, timeout: 30000 }
      );

      if (resp?.data?.success === false) {
        throw new Error(resp?.data?.message || "Failed to send results email");
      }

      setShowConfirmModal(false);
      setShowUpdateEmailModal(false);
      scrollToResults();

      return resp.data;
    } catch (err) {
      console.error("sendResultsToEmail error:", err);
      return null;
    } finally {
      setSendingResults(false);
    }
  };

  const handleConfirmSend = async () => {
    if (!storedEmail) {
      setShowConfirmModal(false);
      setShowUpdateEmailModal(true);
      return;
    }
    await sendResultsToEmail(storedEmail);
  };

  const handleChangeEmail = () => {
    setShowConfirmModal(false);
    setShowUpdateEmailModal(true);
  };

  const handleUpdateEmailAndSend = async (newEmail) => {
    writeUnlock({ email: newEmail });
    setStoredEmail(newEmail);
    await sendResultsToEmail(newEmail);
  };

  const fmtMoney = (n) =>
    (Number(n) || 0).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    });

  return (
    <>
      <div className="min-vh-100 p-4">
        <main className="container">
          <div className="row g-4">
            <div className="col-lg-6">
              <div className="card shadow border-0">
                <div className="card-body border-0">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="bg-primary text-white p-2 rounded">
                      Cryptocurrency Tax Calculator
                    </div>
                    <span className="badge bg-primary-subtle text-primary ms-2">
                      Tax Year {year}
                    </span>
                  </div>

                  <p className="text-muted mb-4 mt-2">
                    Enter your transaction details below.
                  </p>

                  <div className="mb-3">
                    <label className="form-label">Filing Status</label>
                    <select
                      className="form-select"
                      value={filingStatus}
                      onChange={(e) => setFilingStatus(e.target.value)}
                    >
                      <option value="">Select filing status</option>

                      {/* ✅ fixed: values match CONFIG KEYS exactly */}
                      <option value="Single">Single</option>
                      <option value="Married Filing Jointly">
                        Married Filing Jointly
                      </option>
                      <option value="Married Filing Separately">
                        Married Filing Separately
                      </option>
                      <option value="Head of Household">Head of Household</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      Total Taxable Income (excluding crypto gains)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="$500000"
                      value={income}
                      onChange={(e) => setIncome(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      How did you receive your crypto?
                    </label>
                    <select
                      className="form-select"
                      value={acquisitionMethod}
                      onChange={(e) => setAcquisitionMethod(e.target.value)}
                    >
                      <option value="">Select method</option>

                      {/* ✅ fixed: values match computeResults checks */}
                      <option value="purchase">Purchase</option>
                      <option value="payment">As a payment for services</option>
                      <option value="goods">In exchange for goods</option>
                      <option value="gift">Received as a gift</option>
                    </select>
                  </div>

                  {acquisitionMethod === "gift" ? (
                    <>
                      <div className="mb-3">
                        <label className="form-label">
                          Donor&apos;s Original Cost Basis (USD)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          value={giftCostBasis}
                          onChange={(e) => setGiftCostBasis(e.target.value)}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Fair Market Value at Time of Gift (USD)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          value={giftFMV}
                          onChange={(e) => setGiftFMV(e.target.value)}
                        />
                      </div>
                    </>
                  ) : (
                    <div className="mb-3">
                      <label className="form-label">Cost Basis (USD)</label>
                      <input
                        type="number"
                        className="form-control"
                        value={costBasis}
                        onChange={(e) => setCostBasis(e.target.value)}
                      />
                    </div>
                  )}

                  <div className="mb-3">
                    <label className="form-label">
                      Total Proceeds from Sale (USD)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={saleProceeds}
                      onChange={(e) => setSaleProceeds(e.target.value)}
                    />
                  </div>

                  <div className="mb-4">
                    <label className="form-label">
                      How long have you owned this crypto?
                    </label>
                    <div className="form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="short"
                        name="holdingPeriod"
                        value="short"
                        checked={holdingPeriod === "short"}
                        onChange={() => setHoldingPeriod("short")}
                      />
                      <label className="form-check-label" htmlFor="short">
                        One year or less (Short-term)
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="long"
                        name="holdingPeriod"
                        value="long"
                        checked={holdingPeriod === "long"}
                        onChange={() => setHoldingPeriod("long")}
                      />
                      <label className="form-check-label" htmlFor="long">
                        More than one year (Long-term)
                      </label>
                    </div>
                  </div>

                  <button
                    className="btn w-100"
                    onClick={() => {
                      const computed = computeResults();
                      if (!computed) return;

                      setResults(computed.results_json);
                      latestPayloadRef.current = computed;

                      openGateFlow();
                    }}
                    style={{
                      background: "#0f8a4c",
                      borderColor: "#0f8a4c",
                      color: "white",
                    }}
                  >
                    View Results
                  </button>

                  <div className="mt-3">
                    <small className="text-muted">
                      Click <strong>View Results</strong> to unlock your
                      calculation.
                    </small>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Results */}
            <div className="col-lg-6" ref={resultsRef}>
              <div className="card shadow">
                <div className="card-body">
                  <div
                    className="bg-success text-white p-2 rounded"
                    style={{ background: "#0f8a4c" }}
                  >
                    Tax Estimate Results
                  </div>
                  <p className="text-muted mt-2">Your crypto tax breakdown</p>

                  <div
                    className="unk-results-wrap"
                    style={{
                      background: !unlocked
                        ? "linear-gradient(180deg, rgba(255,255,255,0.92), rgba(255,255,255,0.92))"
                        : "transparent",
                    }}
                  >
                    {!unlocked && <div className="unk-bg-blur" />}

                    <div style={{ position: "relative", zIndex: 1, width: "100%" }}>
                      <div className={!unlocked ? "unk-results-blur" : ""}>
                        {results ? (
                          <div className="vstack gap-2">
                            <p className="mb-2">
                              Capital Gain/Loss:{" "}
                              <strong>{fmtMoney(results.capitalGain)}</strong>
                            </p>
                            <p className="mb-2">
                              Estimated Tax Liability:{" "}
                              <strong>{fmtMoney(results.tax)}</strong>
                            </p>
                            <p className="mb-0">
                              Effective Tax Rate:{" "}
                              <strong>
                                {Number(results.effectiveRate || 0).toFixed(1)}%
                              </strong>
                            </p>
                          </div>
                        ) : (
                          <p className="text-muted mb-0">
                            Fill out the form and click calculate to see your
                            estimate.
                          </p>
                        )}
                      </div>

                      {!unlocked && (
                        <div
                          className="unk-results-overlay"
                          onClick={() => {
                            if (!results) {
                              const computed = computeResults();
                              if (!computed) return;

                              setResults(computed.results_json);
                              latestPayloadRef.current = computed;
                            }
                            openGateFlow();
                          }}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              if (!results) {
                                const computed = computeResults();
                                if (!computed) return;

                                setResults(computed.results_json);
                                latestPayloadRef.current = computed;
                              }
                              openGateFlow();
                            }
                          }}
                          aria-label="Results locked. Open unlock modal."
                        >
                          <div className="unk-overlay-card">
                            <div className="unk-overlay-title">Results Locked</div>
                            <div className="unk-overlay-body">
                              Enter your name and email to view your results instantly.
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center text-muted small mt-4 w-50 mx-auto">
            <p>{yearCfg.disclaimer}</p>
          </div>
        </main>
      </div>

      <LeadGateModal
        open={showLeadModal}
        onClose={() => setShowLeadModal(false)}
        onSuccess={(payload) => handleLeadSuccess(payload)}
        calculatorName={calculatorName}
        calculatorYear={String(year)}
        pageUrl={pageUrl}
        endpoint={endpoint}
        resultsJson={latestPayloadRef.current?.results_json || results}
        inputsJson={latestPayloadRef.current?.inputs_json}
        disclaimer={yearCfg.disclaimer}
        pdf_notes={latestPayloadRef.current?.pdf_notes}
      />

      <SuccessModal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        onViewResults={handleSuccessViewResults}
      />

      <ConfirmSendResultsModal
        open={showConfirmModal}
        email={storedEmail}
        onClose={() => setShowConfirmModal(false)}
        onViewResults={() => {
          setShowConfirmModal(false);
          scrollToResults();
        }}
        onSend={handleConfirmSend}
        onChangeEmail={handleChangeEmail}
        sending={sendingResults}
      />

      <UpdateEmailModal
        open={showUpdateEmailModal}
        initialEmail={storedEmail}
        onClose={() => setShowUpdateEmailModal(false)}
        onSend={handleUpdateEmailAndSend}
        sending={sendingResults}
        storedEmail={storedEmail}
        endpoint={PROXY_URL}
        resultsJson={latestPayloadRef.current?.results_json || results}
        inputsJson={latestPayloadRef.current?.inputs_json}
        calculatorName={calculatorName}
        calculatorYear={String(year)}
        pageUrl={pageUrl}
        disclaimer={yearCfg.disclaimer}
        pdf_notes={latestPayloadRef.current?.pdf_notes}
      />
    </>
  );
}

export default CryptocurrencyTaxCalculator;
